import { styled } from 'config/stitches.config'
import Link from 'next/link'

export const StyledLink = styled(Link, {
  'display': 'flex',
  'align-items': 'center',
  'color': 'inherit',
})

